import React from 'react';
import { Link } from 'react-router-dom';
import '../auth.css';
import axios from 'axios';
import i18n from '../i18n';
import {connect} from 'react-redux';
import {reactLocalStorage} from 'reactjs-localstorage';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { Dimmer, Loader, Segment,Icon } from 'semantic-ui-react';
import { API_BASE_URL } from '../utils/endpoints';


class FormLoginDesign extends React.Component {


  constructor(props)
  {
    super(props);
    this.notificationDOMRef = React.createRef();
    this.state={  username:'',  password:'' ,isArabic:false,showOperator:false ,
    OTP:'',showOTP:false,
    token:'',

  };
    this.handleClick = this.handleClick.bind(this);
    
   }

   handleClick=(event)=>{
    event.preventDefault();
    var x=this;
    reactLocalStorage.set("userNameLoggedIN",this.state.username)
  if(this.state.username.length === 0 && this.state.password.length === 0)
  {
  
    toast({
     type: 'warning',
     title:i18n.t('warning.label'),
     description: i18n.t('Please_fill_all_fields.label'),
     animation: 'bounce',
     time: 5000,
    
 });
  }
  else {
    var ip=API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if(ip.includes(s2))
    {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/login";
    }
    else
    {
     apiBaseUrl = ip+"/core/user/rest/auth/login";
    }
    var data="";
    var headers = {
           'Content-Type': 'application/json',
           'username': this.state.username,
           'password':this.state.password
       }
    axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
    {
    if(response.data.failedLoginReason)
    {
     toast({
       type: 'error',
       title: i18n.t('error.label'),
       description:response.data.failedLoginReason,
       animation: 'bounce',
       time: 5000,
      
   });
   setTimeout(function(){
      if(response.data.failedLoginReason === 'Password expired')
   {
     window.location='Reset';
   }}, 3000);
    }
    if(response.status === 200)
    {
     // reactLocalStorage.set('authenticated',response.data.authenticated);
      //reactLocalStorage.get('authenticated');
      var accessToken = response.data.accessToken;
      reactLocalStorage.set('accessToken', accessToken);
      x.setState({ token: accessToken });

    if(response.data.authenticated === true)
    {
  
     var apiBaseUrl;
     if(ip.includes(s2))
     {
       apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/getRole";
     }
     else
     {
      apiBaseUrl = ip+"/core/user/rest/auth/getRole";
     }
     
     var headers = {
            'Content-Type': 'application/json',
            'token': accessToken
        }
        axios.get(apiBaseUrl,{headers: headers}).then(function (response)
       {
         reactLocalStorage.set('role',response.data);
         reactLocalStorage.set('accessToken', accessToken);
         reactLocalStorage.get('role');
         if(response.data === 'ROLE_CMS')
         {
           toast({
             type: 'success',
             title: i18n.t('success.label'),
             description: i18n.t('Login_successfully.label'),
             animation: 'bounce',
             time: 5000,
            
         });
           window.location="Adds";
         }
         else{
      /*      toast({
             type: 'success',
             title: i18n.t('success.label'),
             description: i18n.t('Login_successfully.label'),
             animation: 'bounce',
             time: 5000,
            
         }); */
         
        
         x.SendOtp()
         reactLocalStorage.set('fromLogin',true);
         /*  if(reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
           reactLocalStorage.get("role") === "ROLE_OPERATOR_INT")
           { window.location="/app/dashboard"}
           else{


           x.setState({
             showOTP:true
           });
           x.SendOtp()
           }  */

         }

     
       })
        
    



    }


    }
    else if(response.status === 204){
    toast({
     type: 'error',
     title: i18n.t('error.label'),
     description: i18n.t('Username_password_do_not_match.label'),
     animation: 'bounce',
     time: 5000,
    
 });

    }

    })
    .catch(function (error) {
    console.log(error);
    toast({
     type: 'error',
     title: i18n.t('error.label'),
     description:i18n.t('Something_wrong.label'),
     animation: 'bounce',
     time: 5000,

 });

    });
  }

   }

  
    SendOtp = () => {
 
      var token = this.state.token;
   
    
      var ip = API_BASE_URL;
  
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/otp/login";
      } else {
        apiBaseUrl = ip + "/core/user/rest/auth/otp/login";
      }
  
      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl,{}, { headers: headers }).then(res => {
        const data = res.data.result;
        if(res.data.status=="sucess"){
          this.setState({
            showOTP:true
          });
          toast({
            type: 'success',
            title: i18n.t('success.label'),
            description :res.data.result.message,
            animation: 'bounce',
            time: 5000,
           
        });
        }else{
          toast({
            type: 'error',
            title: i18n.t('error.label'),
            description:res.data.result.message,
            animation: 'bounce',
            time: 5000,
      
        });
        }
         
      });
    };



    verifyOtp =(event)=>{
      event.preventDefault();
     var token = this.state.token
   
    
      var ip = API_BASE_URL;
      var data={
        'otp_code':this.state.OTP
      }
  
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/verify/login";
      } else {
        apiBaseUrl = ip + "/core/user/rest/auth/verify/login";
      }
  
      var headers = { "Content-Type": "application/json", token:token };
      axios.post(apiBaseUrl,data, { headers: headers }).then(res => {
       

        const data = res.data;
     if(data!=undefined){
      if(res.data.status==="sucess"){
        toast({
          type: 'success',
          title: i18n.t('success.label'),
          description :res.data.result.message,
          animation: 'bounce',
          time: 7000,
         
      });
      reactLocalStorage.set('authenticated',true)
          
      window.location="/app/dashboard"

     
     }

       if(res.data.status==="failed"){
      
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:res.data.result.message,
          animation: 'bounce',
          time: 5000,
    
      });
     reactLocalStorage.set('authenticated','false')
     if(res.data.result.message=="Your account was block please call your account manage"){
      window.location="/app";
     }
    //  window.location="/app";
      }
    
      }
     
                
      });
    }
  
       
    onTextBoxChangeSignInOTP = event => {
      this.setState({
        OTP: event.target.value
      });
    };

    onTextBoxChangeSignInEmail = event => {
       this.setState({
         username: event.target.value
       });
       
     };

     onTextBoxChangeSignInPassword = event => {
       this.setState({
         password: event.target.value
       });
     };
 
componentWillMount() {
 /* var lang=i18n.language;
  if(lang ==="ar")
  {
  }*/
 /* 
  if(reactLocalStorage.get('loginDashboard') === 'true')
  {
    window.location='/dashboard'
  }*/
  if( reactLocalStorage.get('lang') ==='ar')
  {
    i18n.changeLanguage('ar');
  }
  else{
    i18n.changeLanguage('en');
  }


}
componentDidMount(){
  reactLocalStorage.set('accessToken','');
  reactLocalStorage.get('accessToken');

reactLocalStorage.set('authenticated',false);
  reactLocalStorage.get('authenticated');
  var lang=i18n.language;
if(lang ==="ar")
{
  this.setState({isArabic:true})

  
  
}

  if(lang ==="ar")
  {
    document.querySelector('.arabic_input').style = 'display:block';
    document.querySelector('.english_input').style = 'display:none';
  }
  else if(lang ==="en") {
    document.querySelector('.arabic_input').style = 'display:none';
    document.querySelector('.english_input').style = 'display:block';
  }
  document.querySelector('.loader').style='display:none';
}
  render(){

    return(
      <div>
    <Segment className='loader'>
      <Dimmer active inverted>
        <Loader size='small'>Loading</Loader>
      </Dimmer>

    </Segment>

      <form onSubmit={this.onFormSubmit} className="ui large form border radius" style={{backgroundColor:'black'}}>
      <div className="stacked segment border_margin">

      <div className="field">
    <div className="english_input" >     
    {!this.state.showOTP &&   <>   
      <div className="ui fluid left icon input" >
       
      <input  placeholder={i18n.t('username.label')}  type="text" className="username"  onChange={this.onTextBoxChangeSignInEmail}/>
      <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}} ></i>
      </div>
      

     
      <div className="field" style={{ marginTop:' 5%'}}>
      <div className="ui fluid left icon input">
      <input  placeholder={i18n.t('Password.label')}  className="password" onChange={this.onTextBoxChangeSignInPassword} type="password"/>
      <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
      </div>
      </div>
      </>}

      {this.state.showOTP &&   <div className="ui fluid left icon input" >
       
       <input  placeholder={i18n.t('otp.label')}  type="text" className="username"  onChange={this.onTextBoxChangeSignInOTP}/>
       <i aria-hidden="true" className="check icon" style={{color:'#2ed9c3 '}} ></i>
       </div>}


</div>
<div className="arabic_input" style={{display:'none'}}> 
{!this.state.showOTP &&   <> 
      <div className="ui fluid right icon input ">
      <input  placeholder={i18n.t('username.label')}  style={{textAlign:'right'}} type="text" className="username"  onChange={this.onTextBoxChangeSignInEmail}/>
      <i aria-hidden="true" className="user icon" style={{color:'#2ed9c3 '}}></i>
      </div>
      

     
      <div className="field" style={{ marginTop:' 5%'}}>
      <div className="ui fluid right icon input">
      <input  placeholder={i18n.t('Password.label')}  style={{textAlign:'right'}}  className="password" onChange={this.onTextBoxChangeSignInPassword} type="password"/>
      <i aria-hidden="true" className="lock icon" style={{color:'#2ed9c3 '}}></i>
      </div>
      </div></>}

      {this.state.showOTP &&   <div className="ui fluid right icon input" >
       
       <input  placeholder={i18n.t('otp.label')}  type="text" className="username"  onChange={this.onTextBoxChangeSignInOTP}/>
       <i aria-hidden="true" className="check icon" style={{color:'#2ed9c3 '}} ></i>
       </div>}

</div>
<br/>
{!this.state.showOTP && <>


      <div className="forgot_div"><Link className="right forgot_text" to="/app/forget">{i18n.t('forgot_pass.label')}</Link></div>
      <div className="forgot_div" style={{marginRight: '12.8%',display:'none'}}><Link className="right forgot_text" to="/app/Code">{i18n.t('i_have_a_password.label')}</Link></div>

    <button type="submit"  className="ui large fluid button btn_login radius" onClick={(event) => this.handleClick(event)}>{i18n.t('Login.label')}</button>
    </>}

    {this.state.showOTP && <>
     

     <button type="submit"  className="ui large fluid button btn_login radius"
      onClick={(event) => this.verifyOtp(event)}>{i18n.t('verify.label')}</button>
 </>}
      </div>   </div> 
      </form>

      <SemanticToastContainer />
      
      </div>
    );
  }

};

const mapStateToProps = (state)=>{

  return state
}

export default connect(mapStateToProps)(FormLoginDesign);
